interface DiscussionUnreadBadgeProps {
    count: number;
}

const DiscussionUnreadBadge = ({ count }: DiscussionUnreadBadgeProps) => {
    if (!count) return null;
    return (
        <span className="badge bg-primary ms-1">{count}</span>
    );
};

export default DiscussionUnreadBadge;
